export default __webpack_public_path__ + "static/media/include_4@2x.2abafb96.jpg";